module.exports = __webpack_public_path__ + "assets/25dd5a07b7f2996de6a6521700fc2a9b.jpg";